import { Component, inject, input } from '@angular/core';
import { filter, Observable, tap } from 'rxjs';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { TagService } from '~app/app/~shared/services/tag.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { Tag } from '~core/models/tag.models';
import { AdvertiserGroupCreationDialogComponent } from '../../modals/advertiser-group-creation-dialog/advertiser-group-creation-dialog.component';
import { DeleteConfirmComponent } from '~app/app/~shared/components/modals/delete-confirm/delete-confirm.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';

@Component({
  selector: 'advertiser-group-list-datatable',
  templateUrl: './advertiser-group-list-datatable.component.html',
  styleUrl: './advertiser-group-list-datatable.component.scss'
})
export class AdvertiserGroupListListDatatableComponent extends BaseComponent {
  private _dialogService = inject(DialogService);
  private _tagService = inject(TagService);
  private _resourceFacade = inject(ResourceFacade);

  groups = input<Tag[]>([]);

  displayedColumns: string[] = ['name', 'actions'];

  openEditDialog(tag: Tag): Observable<unknown> {
    const dialogRef = this._dialogService.open({
      component: AdvertiserGroupCreationDialogComponent,
      fullscreen: true
    });

    dialogRef.componentRef?.setInput('advertiser', tag);

    return dialogRef.afterClosed();
  }

  openDeleteDialog(tag: Tag): void {
    const delete$ = this._tagService.remove(tag.id);

    const dialogRef = this._dialogService.open({
      component: DeleteConfirmComponent,
      config: {
        panelClass: ['mat-dialog-custom'],
        disableClose: true
      }
    });

    dialogRef.componentInstance.removeObservable$ = delete$;
    dialogRef.componentRef?.setInput(
      'title',
      `Voulez-vous supprimer le groupe "${tag.name}" ?`
    );

    dialogRef
      .afterClosed()
      .pipe(
        filter(Boolean),
        takeUntilDestroyed(this._destroyRef),
        tap({
          next: () => {
            this._resourceFacade.getData({ refresh: true });
            this._snackbarService.open({
              text: 'Groupe supprimé avec succès',
              type: 'success'
            });
          }
        })
      )
      .subscribe();
  }
}
